webpackJsonp([185408970092611],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _opportunityItemModule = __webpack_require__(281);
	
	var _opportunityItemModule2 = _interopRequireDefault(_opportunityItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpportunityItem = function (_Component) {
		_inherits(OpportunityItem, _Component);
	
		function OpportunityItem() {
			_classCallCheck(this, OpportunityItem);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		OpportunityItem.prototype.render = function render() {
			var props = this.props;
	
	
			return _react2.default.createElement(
				"div",
				{ className: "row justify-content-between " + _opportunityItemModule2.default.opportunity_item },
				_react2.default.createElement(
					"div",
					{ className: "col-12 col-lg-5" },
					_react2.default.createElement(
						"div",
						{ className: "row justify-content-center" },
						_react2.default.createElement(
							"div",
							{ className: "col-12 col-lg-11" },
							_react2.default.createElement(
								"h3",
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: props.url },
									props.title
								)
							),
							_react2.default.createElement(
								"span",
								null,
								props.location
							)
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "col-12 col-lg-6" },
					_react2.default.createElement(
						"p",
						null,
						props.description
					),
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: props.url },
						"Read more \xBB"
					)
				)
			);
		};
	
		return OpportunityItem;
	}(_react.Component);
	
	exports.default = OpportunityItem;
	module.exports = exports["default"];

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"opportunity_item":"src-components-opportunity-item----opportunity-item-module---opportunity_item---3DyT_"};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(115);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _studyWithUsModule = __webpack_require__(129);
	
	var _studyWithUsModule2 = _interopRequireDefault(_studyWithUsModule);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkup(value) {
		return {
			__html: value
		};
	}
	var StudyWithUs = function StudyWithUs(_ref) {
		var style = _ref.style,
		    title = _ref.title,
		    featuredImage = _ref.featuredImage,
		    description = _ref.description;
		return _react2.default.createElement(
			"div",
			{ className: _studyWithUsModule2.default.outer_wrapper, style: style },
			_react2.default.createElement(
				"div",
				{ className: "container" },
				_react2.default.createElement(
					"div",
					{ className: "row justify-content-center justify-content-lg-between " + _studyWithUsModule2.default.row },
					_react2.default.createElement(
						"div",
						{ className: "col-12 col-md-8 col-lg-7 " + _studyWithUsModule2.default.featured_image },
						_react2.default.createElement(_gatsbyImage2.default, {
							title: featuredImage.title,
							alt: featuredImage.title,
							sizes: featuredImage.sizes
						})
					),
					_react2.default.createElement(
						"div",
						{ className: "col-12 col-md-12 col-lg-6 " + _studyWithUsModule2.default.featured_post },
						_react2.default.createElement(
							"h3",
							null,
							title
						),
						_react2.default.createElement("hr", { className: _studyWithUsModule2.default.hr }),
						_react2.default.createElement("span", { className: "text-dark", dangerouslySetInnerHTML: createMarkup(description) })
					)
				)
			)
		);
	};
	
	exports.default = StudyWithUs;
	module.exports = exports["default"];

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"opportunities_list":"src-components-study-with-us----study-with-us-module---opportunities_list---2FBi6","outer_wrapper":"src-components-study-with-us----study-with-us-module---outer_wrapper---1IoJM","row":"src-components-study-with-us----study-with-us-module---row---1X2Mb","featured_image":"src-components-study-with-us----study-with-us-module---featured_image---3rUB8","featured_post":"src-components-study-with-us----study-with-us-module---featured_post---304LL","hr":"src-components-study-with-us----study-with-us-module---hr---FR4Kv","featured_post_category":"src-components-study-with-us----study-with-us-module---featured_post_category---1ezqj","read_more":"src-components-study-with-us----study-with-us-module---read_more---14HmP"};

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"opportunities_list":"src-styles----careers-module---opportunities_list---1VT5Y"};

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(72);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _SectionTitle = __webpack_require__(53);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _opportunityItem = __webpack_require__(242);
	
	var _opportunityItem2 = _interopRequireDefault(_opportunityItem);
	
	var _careersModule = __webpack_require__(807);
	
	var _careersModule2 = _interopRequireDefault(_careersModule);
	
	var _Button = __webpack_require__(115);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _studyWithUs = __webpack_require__(118);
	
	var _studyWithUs2 = _interopRequireDefault(_studyWithUs);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderJobs = function renderJobs() {
		var jobs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		return jobs.map(function (_ref, i) {
			var node = _ref.node;
	
			if (node.slug !== "sample-entry") {
				return _react2.default.createElement(
					"li",
					{ key: "job-" + (i + 1) },
					_react2.default.createElement(_opportunityItem2.default, {
						id: node.id,
						title: node.title,
						description: node.description.content.excerpt,
						location: node.jobLocation,
						url: "/" + node.node_locale + "/careers/" + node.slug + "-" + node.id.substr(0, 20),
						locale: node.node_locale
					})
				);
			}
			return null;
		});
	};
	
	var Careers = function Careers(_ref2) {
		var transition = _ref2.transition,
		    data = _ref2.data,
		    location = _ref2.location;
		var jobOpportunities = data.jobOpportunities,
		    cta = data.cta,
		    pageSettings = data.pageSettings,
		    bottomBanner = data.bottomBanner;
	
	
		var workWithUs = bottomBanner.edges[0].node;
		return _react2.default.createElement(
			_PageWrapper2.default,
			{
				locale: pageSettings.node_locale,
				location: location,
				data: data.layout.edges[0].node
			},
			_react2.default.createElement(
				"main",
				{ style: transition && transition.style, role: "main" },
				_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle + " | Mahidol Vivax Research Unit" }),
				_react2.default.createElement(
					_Jumbotron2.default,
					{
						className: "mb-0",
						textAlign: "text-center",
						contentAlign: "justify-content-md-center"
					},
					_react2.default.createElement(
						"h1",
						null,
						pageSettings.pageTitle
					),
					_react2.default.createElement(
						"p",
						null,
						pageSettings.metaDescription.metaDescription
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "grey_bg" },
					_react2.default.createElement(
						"div",
						{ className: "container py-5" },
						_react2.default.createElement(
							"div",
							{ className: "row" },
							_react2.default.createElement(
								"div",
								{ className: "col-12" },
								jobOpportunities.edges.length > 1 || jobOpportunities.edges[0].node.slug !== "sample-entry" ? _react2.default.createElement(
									"ul",
									{ className: _careersModule2.default.opportunities_list },
									renderJobs(jobOpportunities.edges)
								) : _react2.default.createElement(
									"div",
									null,
									_react2.default.createElement(
										"p",
										{ className: "text-center mb-0" },
										pageSettings.node_locale === "th" ? "ขณะนี้ยังไม่เปิดรับตำแหน่งงานใหม่" : "There are currently no job opportunities"
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(_CallToAction2.default, {
					className: "my-5",
					text: cta.edges[0].node.content.childMarkdownRemark.html,
					buttonLabel: cta.edges[0].node.buttonLabel,
					destination: "/" + pageSettings.node_locale + cta.edges[0].node.linkTo,
					arrow: true
				}),
				_react2.default.createElement(_studyWithUs2.default, {
					title: workWithUs.title,
					featuredImage: workWithUs.bannerImage,
					description: workWithUs.text.content.html
				})
			)
		);
	};
	
	exports.default = Careers;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-careers-template-js-6f8711b11caf0e3984ed.js